export default function(menu = 'batch', action) {
    if(action.type === 'toggleMenu') {
        return action.menu
    } else {
        return menu;
    }
}